/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cargos_Orders_SectionInputs */

const en_cargos_orders_section = /** @type {(inputs: Cargos_Orders_SectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Orders`)
};

const es_cargos_orders_section = /** @type {(inputs: Cargos_Orders_SectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pedidos`)
};

/**
* | output |
* | --- |
* | "Orders" |
*
* @param {Cargos_Orders_SectionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const cargos_orders_section = /** @type {((inputs?: Cargos_Orders_SectionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cargos_Orders_SectionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cargos_orders_section(inputs)
	return es_cargos_orders_section(inputs)
});